var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass:
        "\n    max-width\n    d-flex\n    flex-grow-1\n    ma-0\n    pa-0\n    fill-height\n    flex-column\n    justify-center\n    text-center\n    align-center align-self-center\n  ",
      staticStyle: { "min-height": "500px" },
      attrs: { elevation: 0, fluid: "" },
    },
    [
      _c(
        "div",
        [
          _c("svg-icon", {
            attrs: { size: "200", iconClass: "Error_Maintenance" },
          }),
          _c("div", { staticClass: "text-h5 text--secondary" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("message_essweb_system_message_systemErrorLabel")
                ) +
                " "
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }